export default __webpack_public_path__ + "static/media/lab.780e3737.jpg";